import React from 'react';
import './TermsModal.css';

const TermsModal = ({ isOpen, onClose, onAgree }) => {
  if (!isOpen) return null;

  return (
    <div className="terms-modal-overlay" onClick={onClose}>
      <div className="terms-modal-content" onClick={e => e.stopPropagation()}>
        <div className="terms-modal-header">
          <h2>使用條款與隱私政策</h2>
          <button className="terms-modal-close" onClick={onClose}>×</button>
        </div>
        <div className="terms-modal-body">
          <section className="terms-section">
            <h3>1. 接受條款</h3>
            <p>歡迎使用我們的網站。通過訪問或使用本網站，您同意遵守並受本使用條款的約束。如果您不同意這些條款，請不要使用本網站。</p>
          </section>

          <section className="terms-section">
            <h3>2. 網站使用</h3>
            <div className="terms-subsection">
              <h4>2.1 使用權限</h4>
              <ul>
                <li>本網站僅供個人、非商業用途使用</li>
                <li>您必須遵守所有適用的法律法規</li>
                <li>您不得干擾或破壞網站的正常運作</li>
              </ul>
            </div>

            <div className="terms-subsection">
              <h4>2.2 用戶責任</h4>
              <ul>
                <li>您需要對使用本網站的所有活動負責</li>
                <li>您不得使用本網站進行任何非法活動</li>
                <li>您不得嘗試未經授權訪問網站的任何部分</li>
              </ul>
            </div>
          </section>

          <section className="terms-section">
            <h3>3. 隱私政策</h3>
            <div className="terms-subsection">
              <h4>3.1 信息收集</h4>
              <ul>
                <li>我們可能收集您自願提供的信息</li>
                <li>我們使用 cookies 來改善用戶體驗</li>
                <li>我們不會出售或出租您的個人信息</li>
              </ul>
            </div>

            <div className="terms-subsection">
              <h4>3.2 信息使用</h4>
              <ul>
                <li>我們使用收集的信息來提供和改進服務</li>
                <li>我們可能使用您的信息來發送重要通知</li>
                <li>我們會採取適當的安全措施保護您的信息</li>
              </ul>
            </div>
          </section>

          <section className="terms-section">
            <h3>4. 智慧財產權</h3>
            <div className="terms-subsection">
              <h4>4.1 版權</h4>
              <ul>
                <li>本網站的所有內容均受版權法保護</li>
                <li>未經許可，不得複製、修改或分發網站內容</li>
                <li>所有商標和標誌均為其各自所有者的財產</li>
              </ul>
            </div>

            <div className="terms-subsection">
              <h4>4.2 用戶內容</h4>
              <ul>
                <li>您保留您提交到網站的內容的所有權利</li>
                <li>您授予我們使用、修改和展示您內容的許可</li>
                <li>您確保您擁有提交內容的所有必要權利</li>
              </ul>
            </div>
          </section>

          <section className="terms-section">
            <h3>5. 免責聲明</h3>
            <div className="terms-subsection">
              <h4>5.1 服務可用性</h4>
              <ul>
                <li>我們不保證網站將始終可用或無錯誤</li>
                <li>我們保留隨時修改或終止服務的權利</li>
                <li>我們不對服務中斷負責</li>
              </ul>
            </div>

            <div className="terms-subsection">
              <h4>5.2 內容準確性</h4>
              <ul>
                <li>我們不保證網站內容的準確性或完整性</li>
                <li>您應自行判斷網站內容的可靠性</li>
                <li>我們不對因使用網站內容而造成的損失負責</li>
              </ul>
            </div>
          </section>

          <section className="terms-section">
            <h3>6. 責任限制</h3>
            <ul>
              <li>在法律允許的最大範圍內，我們不對任何間接、偶然、特殊或後果性損害負責</li>
              <li>我們對因使用或無法使用本網站而造成的任何損害的責任不超過您支付的費用（如果有的話）</li>
            </ul>
          </section>

          <section className="terms-section">
            <h3>7. 條款修改</h3>
            <ul>
              <li>我們保留隨時修改這些條款的權利</li>
              <li>修改後的條款將在網站上發布</li>
              <li>繼續使用本網站即表示您接受修改後的條款</li>
            </ul>
          </section>

          <section className="terms-section">
            <h3>8. 適用法律</h3>
            <ul>
              <li>本條款受中華民國法律管轄</li>
              <li>任何爭議應提交至有管轄權的法院解決</li>
            </ul>
          </section>
          <div className="last-updated">最後更新日期：2025年5月</div>
          <div className="terms-modal-footer">
            <button className="terms-agree-btn" onClick={() => {
              onAgree();
              onClose();
            }}>
              我同意以上條款
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsModal; 